import type { FilingPlan } from '../shared/desktop-api';
import { reasonOf } from './destination-channel';
import type { PaigeFilingPlanChannel, PaigeJobFilingPlan } from './paige.global';

/**
 * The job's file naming over the job's channel (`{engineOrigin}/filing-plan`, the contract's
 * getJobFilingPlan and putJobFilingPlan): one naming per job, used by every destination that writes
 * files. A save the API refuses (a field the type does not have, a slash in a separator, ...)
 * rejects with the API's reason, which the card shows in place.
 */
export function filingPlanChannel(
  engineOrigin: string,
  tenant: string | undefined,
): PaigeFilingPlanChannel {
  const send = async (method: 'GET' | 'PUT', plan?: FilingPlan) => {
    const response = await fetch(`${engineOrigin}/filing-plan`, {
      method,
      credentials: 'include',
      headers: {
        ...(plan ? { 'content-type': 'application/json' } : {}),
        ...(method === 'PUT' ? { 'Idempotency-Key': crypto.randomUUID() } : {}),
        ...(tenant ? { 'Paige-Tenant': tenant } : {}),
      },
      ...(plan ? { body: JSON.stringify(plan) } : {}),
    });
    if (!response.ok) throw new Error(await reasonOf(response));
    return (await response.json()) as PaigeJobFilingPlan;
  };
  return { read: () => send('GET'), save: (plan) => send('PUT', plan) };
}
